export enum ArticleFaceType {
	Visible = 0,
	Back = 1,
	Both = 2,
}
